module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d07-ce2a012c43f0d586ec241cc9f10b48f9.jpg";